// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"JN-z","carouselContainer":"KN-z"};